<template>
	<div class="modal modal--board-command modal-board-command">
		<div class="modal__loading" v-if="isLoading">
			<loading-spinner />
		</div>
		<div class="modal-board-command__form">
			<iframe :src="`https://csbank.formstack.com/forms/boardcommand_support?${formParams}`" width="100%" height="580" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen="" id="form_frame"></iframe>
		</div>
	</div>
</template>

<script>
import LoadingSpinner from '@/components/LoadingSpinner'

export default {
	name: 'ModalBoardCommand',
	comments: {
		LoadingSpinner,
	},
	computed: {
		me() {
			return this.$store.getters['user/me']
		},
		formParams() {
			let string = ``
			const _params = {
				'field192557065': this.me?.firstName,
				'field192557064': this.me?.lastName,
				'field192557046': this.me?.email,
				'field192557045': this.me?.organization?.name,
				'field125193248': this.me?.organization?.address?.state,
			}

			for (const key in _params) {
				string += `${key}=${_params[key]}&`
			}
			return string
		},
		isLoading() {
			return false
		}
	}
}
</script>

<style scoped lang="scss">
.modal-board-command {
	&__form {
		width: 640px;
		max-width: 100%;
	}
}
</style>
